import ScrollBar from "react-perfect-scrollbar";
import { Card, CardBody, Col } from "reactstrap";
import { Badges, LI, OL } from "../../../../AbstractElements";
import { badgeScrollData, badgesScrollSubTitle } from "../../../../Data/BonusUi/Scrollable";
import CommonCardHeader from "../../../../Utils/CommonComponents/CommonCardHeader";
import { BadgesScrollbarTitle } from "../../../../Utils/Constants";

export default function BadgesScrollbar() {
  return (
    <Col xxl={4} md={6}>
      <Card>
        <CommonCardHeader headClass="pb-0" title={BadgesScrollbarTitle} subTitle={badgesScrollSubTitle} />
        <CardBody>
          <ScrollBar className="scroll-demo" style={{ width: "100%", height: "300px" }}>
            <OL className="list-group list-group-numbered scroll-rtl">
              {badgeScrollData &&
                badgeScrollData.map((item, index) => (
                  <LI className={`d-flex align-items-start flex-wrap`} key={index}>
                    <div className="ms-2 me-auto">{item.text}</div>
                    <Badges color={item.class} className={`p-2 ${index !== 0 ? "text-white" : ""}`} pill>
                      {item.badge}
                    </Badges>
                  </LI>
                ))}
            </OL>
          </ScrollBar>
        </CardBody>
      </Card>
    </Col>
  );
}
